module.exports = __webpack_public_path__ + "fonts/Arturito-Slab-2.e4cac5c9.ttf";